class StickyElement {
  constructor(element) {
    this.isStickyTop = false;
    this.isStickyBottom = false;
    this.lastScrollTop = 0;
    this.element = element;
    this.elementWidth = element.offsetWidth;
    this.elementContent = this.element.querySelector('[data-sticky-content]');
  }

  _stickToTop() {
    this.elementContent.classList.add('is-sticky-top');
    this.elementContent.setAttribute('style', `width: ${this.elementWidth}px`);
    this.isStickyTop = true;
  }

  _stickToBottom() {
    this.elementContent.classList.remove('is-sticky-top');
    this.elementContent.classList.add('is-sticky-bottom');
    this.isStickyBottom = true;
  }

  _removeStickyTop() {
    this.elementContent.classList.remove('is-sticky-top');
    this.elementContent.removeAttribute('style');
    this.isStickyTop = false;
  }

  _removeStickyBottom() {
    this.elementContent.classList.remove('is-sticky-bottom');
    this.isStickyBottom = false;
  }

  _toggleState() {
    const elementPos = this.element.getBoundingClientRect();
    const elementContentPos = this.elementContent.getBoundingClientRect();
    const windowScrollPos = window.pageYOffset || document.documentElement.scrollTop;

    if (this.elementContent.offsetHeight >= this.element.offsetHeight) {
      return false;
    }

    if (elementPos.top >= 0 && this.isStickyTop) {
      this._removeStickyTop();
    }

    if (windowScrollPos > this.lastScrollTop) {
      if (elementContentPos.top <= 0 && !this.isStickyTop) {
        this._stickToTop();
      }

      if (elementPos.bottom <= elementContentPos.bottom && !this.isStickyBottom) {
        this._stickToBottom();
      }
    } else {
      if (elementContentPos.top >= 0 && this.isStickyBottom) {
        this._stickToTop();
        this._removeStickyBottom();
      }

      if (elementPos.top >= 0 && this.isStickyTop) {
        this._removeStickyTop();
      }
    }

    this.lastScrollTop = windowScrollPos;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  for (const e of document.querySelectorAll('[data-sticky]')) {
    const stickyElement = new StickyElement(e);
    window.addEventListener('scroll', () => stickyElement._toggleState());
  }
});
